import type {ReactElement} from 'react';
import {Controller, useFormContext} from 'react-hook-form';
import {InputField} from '@Components/input-field-v2';
import {InputFieldSize, InputFieldState} from '@Components/input-field-v2/input-field.types';
import type {TextFieldRendererProps} from './fields.types';
import styles from './fields.module.scss';

export function TextFieldRenderer({name, step, field}: TextFieldRendererProps): ReactElement {
  const {control} = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      defaultValue=""
      rules={{
        maxLength: field.maxLength,
      }}
      render={({field: rhfField, fieldState}): ReactElement => {
        const value = typeof rhfField.value === 'string' ? rhfField.value : '';
        return (
          <InputField
            isMultiline
            useEmptyPlaceholder
            inputClassName={`_borderless ${styles.textArea}`}
            placeholder={field.placeholder}
            input={value}
            size={InputFieldSize.MEDIUM}
            maxLength={field.maxLength}
            maxNumberOfRows={2}
            elementTitle={step.helpText}
            state={fieldState.invalid ? InputFieldState.ERROR : InputFieldState.DEFAULT}
            onInputChange={(val): void => {
              rhfField.onChange(String(val));
            }}
            onInputBlur={(): void => {
              rhfField.onBlur();
            }}
          />
        );
      }}
    />
  );
}
